import { render } from "./Fp_about.vue?vue&type=template&id=3ff81e6e&scoped=true"
import script from "./Fp_about.vue?vue&type=script&lang=js"
export * from "./Fp_about.vue?vue&type=script&lang=js"

import "./Fp_about.vue?vue&type=style&index=0&id=3ff81e6e&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff81e6e"]])

export default __exports__